import React from "react";
import { Col, ColorPicker, Row, Space } from "antd";
import { ColumnProps } from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  { key: "1", title: "ID", dataIndex: "id", width: "5%" },
  {
    key: "2",
    title: "Tên máy",
    dataIndex: "tenMayCDHA",
    align: "left",
    width: "70%",
  },
  {
    key: "3",
    title: "Mã máy",
    dataIndex: "maMayCDHA",
    align: "left",
    width: "20%",
  },

  { key: "4", title: "Thao tác", dataIndex: "action", width: "5%" },
];
export { columns };
